export interface GetCollectionListBibliographyInfoRequest {
  bibliographyRealIds: number[]
  collectionId: number
  collectionNo: string
  fileName: string
}

export function GetCollectionListBibliographyInfoRequestToJSON(
  value: GetCollectionListBibliographyInfoRequest
): any {
  return {
    bibliography_real_ids:
      value.bibliographyRealIds.length > 0
        ? value.bibliographyRealIds
        : undefined,
    collection_id: value.collectionId !== 0 ? value.collectionId : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined,
    file_name: value.fileName !== '' ? value.fileName : undefined
  }
}
